module["exports"] = [
  "####"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/de_AT/address/postcode.js
 ** module id = 356
 ** module chunks = 0
 **/